// src/components/FilterModal.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FilterModal.css';
import { IoIosCloseCircleOutline } from "react-icons/io";

const FilterModal = ({ isOpen, onClose, onApply }) => {
    console.log('FilterModal rendered with isOpen:', isOpen);

    const [filters, setFilters] = useState({});
    const navigate = useNavigate();

    const toggleBooleanFilter = (key) => {
        setFilters(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const toggleFilter = (category, key) => {
        setFilters(prev => ({
            ...prev,
            [category]: {
                ...(prev[category] || {}),
                [key]: !(prev[category]?.[key])
            }
        }));
    };

    const toggleArrayFilter = (key, value) => {
        setFilters(prev => {
            const currentArray = prev[key] || [];
            const newArray = currentArray.includes(value)
                ? currentArray.filter(item => item !== value)
                : [...currentArray, value];
            return {
                ...prev,
                [key]: newArray
            };
        });
    };

    const handleApply = () => {
        onApply(filters);
    };

    const handleBackgroundClick = (e) => {
        if (e.target.className === 'modal') {
            onClose();
        }
    };

    return (
        <div className="modal" onClick={handleBackgroundClick}>
            <div className="filter-modal-content" onClick={e => e.stopPropagation()}>
                <div className="filter-section">
                    <h2>Service Hours</h2>
                    {['Day Services', 'Overnight Services', 'Specific Time Services', 'All-Day Services'].map(hour => (
                        <div key={hour} className="filter-option" onClick={() => toggleArrayFilter('serviceHours', hour)}>
                            <span>{hour}</span>
                            <input type="checkbox" checked={(filters.serviceHours || []).includes(hour)} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Languages</h2>
                    {['English', 'French', 'French-limited', 'Spanish'].map(language => (
                        <div key={language} className="filter-option" onClick={() => toggleArrayFilter('languages', language)}>
                            <span>{language}</span>
                            <input type="checkbox" checked={(filters.languages || []).includes(language)} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Resources</h2>
                    {[
                        { key: 'hasAvailableBeds', label: 'Beds Available' },
                        { key: 'hasFood', label: 'Food Available' },
                        { key: 'hasWellness', label: 'Wellness Services' },
                        { key: 'hasOtherResources', label: 'Other Resources' }
                    ].map(resource => (
                        <div key={resource.key} className="filter-option" onClick={() => toggleBooleanFilter(resource.key)}>
                            <span>{resource.label}</span>
                            <input type="checkbox" checked={filters[resource.key]} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Health Resources</h2>
                    {[
                        { key: 'available', label: 'Available' },
                        { key: 'requiresOHIP', label: 'Requires OHIP' },
                        { key: 'requiresID', label: 'Requires ID' }
                    ].map(option => (
                        <div key={option.key} className="filter-option" onClick={() => toggleFilter('healthResources', option.key)}>
                            <span>{option.label}</span>
                            <input type="checkbox" checked={filters.healthResources?.[option.key]} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Mental Health Support</h2>
                    {[
                        { key: 'available', label: 'Available' },
                        { key: 'requiresOHIP', label: 'Requires OHIP' },
                        { key: 'requiresID', label: 'Requires ID' }
                    ].map(option => (
                        <div key={option.key} className="filter-option" onClick={() => toggleFilter('mentalHealthSupport', option.key)}>
                            <span>{option.label}</span>
                            <input type="checkbox" checked={filters.mentalHealthSupport?.[option.key]} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Gender</h2>
                    {['Male', 'Female', 'Gender Neutral', 'All'].map(gender => (
                        <div key={gender} className="filter-option" onClick={() => toggleArrayFilter('gender', gender)}>
                            <span>{gender}</span>
                            <input type="checkbox" checked={(filters.gender || []).includes(gender)} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Age</h2>
                    {['Minors', 'Adults', 'Seniors', 'All'].map(age => (
                        <div key={age} className="filter-option" onClick={() => toggleArrayFilter('age', age)}>
                            <span>{age}</span>
                            <input type="checkbox" checked={(filters.age || []).includes(age)} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Groups & Policies</h2>
                    {[
                        { key: 'allowsFamilies', label: 'Allows Families' },
                        { key: 'allowsImmigrants', label: 'Allows Immigrants' },
                        { key: 'allowsLGBTQ', label: 'Allows LGBTQ' },
                        { key: 'allowsPets', label: 'Allows Pets' },
                        { key: 'allowsDrugs', label: 'Allows Drugs' },
                        { key: 'allowsAlcohol', label: 'Allows Alcohol' }
                    ].map(policy => (
                        <div key={policy.key} className="filter-option" onClick={() => toggleBooleanFilter(policy.key)}>
                            <span>{policy.label}</span>
                            <input type="checkbox" checked={filters[policy.key]} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Requirements</h2>
                    {[
                        { key: 'hasFees', label: 'Has Fees' },
                        { key: 'requiresDocuments', label: 'Requires Documents' },
                        { key: 'requiresApplication', label: 'Requires Application' }
                    ].map(requirement => (
                        <div key={requirement.key} className="filter-option" onClick={() => toggleBooleanFilter(requirement.key)}>
                            <span>{requirement.label}</span>
                            <input type="checkbox" checked={filters[requirement.key]} readOnly />
                        </div>
                    ))}
                </div>
                <div className="filter-section">
                    <h2>Accessibility</h2>
                    <div className="filter-option" onClick={() => toggleBooleanFilter('isFullyAccessible')}>
                        <span>Fully Accessible</span>
                        <input type="checkbox" checked={filters.isFullyAccessible} readOnly />
                    </div>
                </div>
                <div className="button-container">
                    <button className="clear-btn" onClick={() => setFilters({})}>Clear All</button>
                    <button className="apply-btn" onClick={handleApply}>Apply</button>
                </div>
            </div>
        </div>
    );
};

export default FilterModal;
